import type { PaymentCategory } from '../../types/financialReport';

const categoryConfig: Record<PaymentCategory, { label: string; classes: string }> = {
  paid: { label: 'Paga', classes: 'bg-green-100 text-green-800' },
  partial: { label: 'Parcial', classes: 'bg-amber-100 text-amber-800' },
  issued: { label: 'Emitida', classes: 'bg-blue-100 text-blue-800' },
  overdue: { label: 'Vencida', classes: 'bg-red-100 text-red-800' },
  notissued: { label: 'Por emitir', classes: 'bg-gray-100 text-gray-700' },
  cancelled: { label: 'Cancelada', classes: 'bg-gray-100 text-gray-500 line-through' },
  draft: { label: 'Rascunho', classes: 'bg-gray-100 text-gray-700' },
  none: { label: '—', classes: 'bg-gray-50 text-gray-400' },
};

interface PaymentStatusBadgeProps {
  category: PaymentCategory;
  rawStatus?: string;
  daysOverdue?: number;
  /** A supplier's invoice already received reads as something to pay. */
  side?: 'client' | 'supplier';
}

export function PaymentStatusBadge({ category, rawStatus, daysOverdue, side }: PaymentStatusBadgeProps) {
  const config = categoryConfig[category] || categoryConfig.none;
  const label =
    category === 'overdue' && daysOverdue && daysOverdue > 0
      ? `Vencida · ${daysOverdue}d`
      : side === 'supplier' && category === 'issued'
        ? 'Por pagar'
        : config.label;

  return (
    <span
      className={`cm-chip ${config.classes}`}
      title={rawStatus || label}
    >
      {label}
    </span>
  );
}
